import { SwapHorizontalIcon } from './SwapHorizontalIcon';

/**
 * author: Google
 * id D1E543C5-6ECA-43AA-B04D-438319BC5562
 * name swap-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-horizontal.svg
 * tags
 * - Arrow 
 */
export const ExchangeIcon = SwapHorizontalIcon;
export default ExchangeIcon